import moment from 'moment';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Logger } from '../../config/logging/logger';

const ONLY_HOME_DEPOT_GO_LIVE_DATE = process.env.REACT_APP_ONLY_HOME_DEPOT_GO_LIVE_DATE;
const logger = Logger.create('DateUtils');

export function isPriorCompanyEnrollment(enrollmentDate: string | undefined): boolean {
  logger.debug(Logger.format(`EnrollmentDate: ${enrollmentDate}`));
  logger.debug(Logger.format(`Live date: ${ONLY_HOME_DEPOT_GO_LIVE_DATE}`));
  if (!enrollmentDate || !ONLY_HOME_DEPOT_GO_LIVE_DATE) {
    return false;
  }
  // Convert to UTC Moment objects
  const enrollmentDateMomentUtc = moment.utc(enrollmentDate);
  const liveDateMomentUtc = moment.utc(ONLY_HOME_DEPOT_GO_LIVE_DATE);

  // Compare the dates
  return enrollmentDateMomentUtc.isBefore(liveDateMomentUtc);
}

export function getFormattedDate(date: string) {
  return moment(date).format('MMMM DD, YYYY');
}

export function formatLastUpdated(dateInput: string | Date): string {
  dayjs.extend(relativeTime);

  const input = dayjs(dateInput);
  return `Last updated ${input.fromNow()}`;
}
